module.exports = __webpack_public_path__ + "static/media/identity_hsl_slices-min.62978a4a.gif";